"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
function AppListLoader() {
    return (common_utils_1.isolateComponent(react_1.Fragment, null,
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" }),
        common_utils_1.isolateComponent(design_system_1.SkeletonBlock, { height: 38, width: "100%" })));
}
exports.default = AppListLoader;
